(function () {
  function bindHeroScroll() {
    var hero = document.querySelector('.eride-hero');
    var intro = document.querySelector('.eride-intro');
    if (!hero || !intro || hero.dataset.scrollBound === 'true') return;

    hero.dataset.scrollBound = 'true';

    var content = hero.querySelector('.eride-hero__content');
    var mediaInner = hero.querySelector('.eride-hero__media-inner');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ticking = false;

    function updateHeroScroll() {
      ticking = false;
      if (reducedMotion) return;

      var introTop = intro.getBoundingClientRect().top;
      var viewport = window.innerHeight || 1;
      var progress = Math.min(1, Math.max(0, 1 - introTop / viewport));

      if (content) {
        content.style.opacity = String(1 - progress);
        content.style.transform = 'translateY(' + progress * -28 + 'px)';
      }

      if (mediaInner) {
        mediaInner.style.transform = 'scale(' + (1 + progress * 0.05) + ')';
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateHeroScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateHeroScroll();
  }

  document.addEventListener('eride:hero-stack-ready', bindHeroScroll);
  document.addEventListener('DOMContentLoaded', bindHeroScroll);
  document.addEventListener('shopify:section:load', bindHeroScroll);
  bindHeroScroll();
})();
